import { ReactComponent as StarFilled } from "./star-red-filled.svg";
import { ReactComponent as StarEmpty } from "./star-empty.svg";

function Rating(props) {
  const ratings = props.rating;
  let i = 0;
  let j = 0;
  let ratingArray = [];
  while (i < ratings) {
    ratingArray.push(i);
    i++;
  }

  const zeroRatings = 5 - ratings;

  let zeroRatingArray = [];
  while (j < zeroRatings) {
    zeroRatingArray.push(j);
    j++;
  }
  return (
    <div className="ratings">
      {ratingArray.map((i) => {
        return <StarFilled className="star" key={i} />;
      })}

      {zeroRatingArray.map((i) => {
        return <StarEmpty className="star" key={i} />;
      })}
    </div>
  );
}

export default Rating;
